export const PrioritiesColumns = onChange => ([
  {
    label: <span className="playbook-list-table-header">Priority</span>,
    value: 'priority',
    onClick: onChange,
    sortable: true,
    width: '130px'
  },
  {
    label: <span className="playbook-list-table-header">Playbook</span>,
    value: 'name',
    sortable: false
  },
  {
    label: <span className="playbook-list-table-header">Last Updated</span>,
    value: 'updatedAt',
    sortable: false,
    width: '50%'
  }
])



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Prioritize/PlaybookPrioritiesTable/constants.js